<template>
    <span>{{data}}</span>
</template>
<script>
export default {
  data () {
    return {
      data: ''
    }
  },
  props: ['value'],
  watch: {
    value: 'handleValueChange'
  },
  methods: {
    textChange (value) {
      // debugger
      if (value.auditstatus === 0) {
        this.data = '未审核、禁用'
      } else if (value.auditstatus === 2) {
        this.data = '未通过、禁用'
      } else if (value.auditstatus === 1 && value.enabled) {
        this.data = '通过、可使用'
      } else if (value.auditstatus === 1 && !value.enabled) {
        this.data = '通过、禁用'
      }
    },
    handleValueChange (val, oldVal) {
      this.textChange(val)
    }
  },
  created () {
    // debugger
    this.textChange(this.value)
  }
}
</script>
